import { combineEpics, ofType } from "redux-observable";
import {
    EMPTY,
    catchError,
    concatMap,
    map,
    mergeMap,
    of,
    switchMap,
    withLatestFrom,
} from "rxjs";

import { RootState } from "../../../store/ConfigureStore";
import {
    getChargePumpList,
    GetCPCapacityGraphData,
    GetEquipmentsForChargePumps,
    getGKXCapacityGraphData,
    getGKXListData,
    getSpecialPumpsCalculations,
} from "../../../services/calculations/calculation-output/gasCalculation.service";
import {
    setChargePump1EquipmentsDropdown,
    setChargePump2EquipmentsDropdown,
    setChargePump2Name,
    setChargePump3EquipmentsDropdown,
    setChargePump3Name,
    setChargePumpList,
    setChargePumpList2,
    setChargePumpList3,
    setChargePumpName,
    setCP1GraphData,
    setCP2GraphData,
    setCP3GraphData,
    setExistedSRGasPump1Equipments,
    setExistedSRGasPump2Equipments,
    setExistedSRGasPump3Equipments,
    setGasGKXList,
    setGasHandlerEquipmentsDropdown,
    setGasNotification,
    setGKXPumpCapcityGraphData,
    setShowHideGasHandlerEquipment,
    setShowHideSRGasPump1Equipment,
    setShowHideSRGasPump2Equipment,
    setShowHideSRGasPump3Equipment,
} from "../../../store/calculation/calculation-output/gasCalculaionSlice";
import { from } from "rxjs";
import { setCP1CalculationData, setCP2CalculationData, setCP3CalculationData, setGasHandlerPumpName, setGKXCalculationData } from "../../../store/calculation/calculation-output/gasHandlerSlice";
import { fetchEquipmentsForHandler } from "../../../services/calculations/calculation-output/gasHandler.service";
import { GetChargePumpListPayload } from "../../../store/model/calculations/calculation";

const getGKXList = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setCatalogType",
            "gasCalculation/setGasSeparatorList",
            "tubing/setChargePumpShowAll"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)
            ),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut))
        ),
        concatMap(([actionData, tab1Input, gasData, gasOutput]) => {
            let preTFV = "";
            var GKXVal = gasData?.useOfChgPmp;
            var GKXSelVal = gasData?.chargePumpGKX;
            var noOfGasSeps = +gasData?.noOfGasSeps;
            var selctdGasSep = gasData?.sepSelcted;

            if (GKXVal === "1" && gasOutput !== undefined) {
                if (GKXSelVal !== "") {
                    preTFV = gasOutput?.GKX_TotalFluidVolume?.toString()
                }
                else {
                    if (noOfGasSeps > 0) {
                        if (selctdGasSep != "") {
                            if (selctdGasSep?.trim() != "") {
                                if (noOfGasSeps == 1) {
                                    preTFV = gasOutput?.SP1_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 2) {
                                    preTFV = gasOutput?.SP2_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 3) {
                                    preTFV = gasOutput?.SP3_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 4) {
                                    preTFV = gasOutput?.SP4_TotalFluidVolume?.toString()
                                }
                            }
                        }
                        else {
                            preTFV = gasOutput?.Intake_TotalFluidVolume?.toString() || ''
                        }
                    }
                    else {
                        preTFV = gasOutput?.Intake_TotalFluidVolume?.toString() || ''
                    }
                }
            }
            else {
                if (noOfGasSeps > 0) {
                    if (selctdGasSep != "") {
                        if (selctdGasSep?.trim() != "") {
                            if (noOfGasSeps == 1) {
                                preTFV = gasOutput?.SP1_TotalFluidVolume?.toString()
                            }
                            else if (noOfGasSeps == 2) {
                                preTFV = gasOutput?.SP2_TotalFluidVolume?.toString()
                            }
                            else if (noOfGasSeps == 3) {
                                preTFV = gasOutput?.SP3_TotalFluidVolume?.toString()
                            }
                            else if (noOfGasSeps == 4) {
                                preTFV = gasOutput?.SP4_TotalFluidVolume?.toString()
                            }
                        }
                    }
                    else {
                        preTFV = gasOutput?.Intake_TotalFluidVolume?.toString()
                    }
                }
                else {
                    preTFV = gasOutput?.Intake_TotalFluidVolume?.toString()
                }
            }
            preTFV = preTFV === undefined ? gasOutput?.Intake_TotalFluidVolume : preTFV;
            const preTFVUnit = tab1Input?.hdnGas_TotalFluidVolume;
            const catalogFilter =
                actionData?.type === "tubing/setCatalogType"
                    ? actionData?.payload
                    : +tab1Input?.catalogType;
            const payload = {
                TFV: preTFV ?? 0,
                unitSys: preTFVUnit,
                catalogFilter: catalogFilter,
            };
            return from(getGKXListData(payload)).pipe(
                mergeMap((data) => {
                    const records = data?.GKXList;
                    if (!records) return [];
                    const arrayValue = Object.keys(records).map((key) => ({
                        value: records[key],
                        label: key,
                    }));
                    const gasHandlerName = arrayValue?.length > 0 ? arrayValue?.find(x => x?.value === gasData?.chargePumpGKX) : null;
                    arrayValue.unshift({ value: "", label: "Select" });
                    return [
                        setGasHandlerPumpName(gasHandlerName?.label ?? ""),
                        setGasGKXList(arrayValue)
                    ];
                })
            );
        })
    );
};

const getChPumpList = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setCatalogType",
            "gasCalculation/setGasGKXList"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state.tubing.tab1Input)),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)
            ),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)
            )
        ),
        concatMap(
            ([actionData, tab1Input, gasData, gasOutput]) => {
                let preTFV = "";
                var GKXVal = gasData?.useOfChgPmp;
                var GKXSelVal = gasData?.chargePumpGKX;
                var noOfGasSeps = +gasData?.noOfGasSeps;
                var selctdGasSep = gasData?.sepSelcted;

                if (GKXVal === "1" && gasOutput !== undefined) {
                    if (GKXSelVal != "") {
                        preTFV = gasOutput?.GKX_TotalFluidVolume?.toString()
                    }
                    else {
                        if (noOfGasSeps > 0) {
                            if (selctdGasSep != "") {
                                if (selctdGasSep?.trim() != "") {
                                    if (noOfGasSeps == 1) {
                                        preTFV = gasOutput?.SP1_TotalFluidVolume?.toString()
                                    }
                                    else if (noOfGasSeps == 2) {
                                        preTFV = gasOutput?.SP2_TotalFluidVolume?.toString()
                                    }
                                    else if (noOfGasSeps == 3) {
                                        preTFV = gasOutput?.SP3_TotalFluidVolume?.toString()
                                    }
                                    else if (noOfGasSeps == 4) {
                                        preTFV = gasOutput?.SP4_TotalFluidVolume?.toString()
                                    }
                                }
                            }
                            else {
                                preTFV = gasOutput?.Intake_TotalFluidVolume?.toString() || ''
                            }
                        }
                        else {
                            preTFV = gasOutput?.Intake_TotalFluidVolume?.toString() || ''
                        }
                    }
                }
                else {
                    if (noOfGasSeps > 0) {
                        if (selctdGasSep != "") {
                            if (selctdGasSep?.trim() != "") {
                                if (noOfGasSeps == 1) {
                                    preTFV = gasOutput?.SP1_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 2) {
                                    preTFV = gasOutput?.SP2_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 3) {
                                    preTFV = gasOutput?.SP3_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 4) {
                                    preTFV = gasOutput?.SP4_TotalFluidVolume?.toString()
                                }
                            }
                        }
                        else {
                            preTFV = gasOutput?.Intake_TotalFluidVolume?.toString()
                        }
                    }
                    else {
                        preTFV = gasOutput?.Intake_TotalFluidVolume?.toString()
                    }
                }
                preTFV = preTFV === undefined ? gasOutput?.Intake_TotalFluidVolume : preTFV;
                const casingOD = tab1Input?.casingOD?.toString();
                const unitSys = tab1Input?.unitSys?.toString();
                const preTFVUnit = tab1Input?.hdnGas_TotalFluidVolume;
                const chargePumpShowAll = tab1Input?.chargePumpShowAll || false;

                const catalogFilter =
                    actionData.type === "tubing/setCatalogType"
                        ? actionData.payload
                        : +tab1Input?.catalogType;
                const payload = {
                    CasingOD: casingOD,
                    TFV: +preTFV,
                    UnitSys: unitSys,
                    TFVUnit: preTFVUnit,
                    catalogFilter: catalogFilter,
                    chargePumpShowAll: chargePumpShowAll,
                } as GetChargePumpListPayload;

                return from(getChargePumpList(payload)).pipe(
                    mergeMap((data) => {
                        const records = data?.ChrgePmpList;
                        if (!records) return [];
                        const arrayValue = Object.keys(records).map((key) => ({
                            value: records[key],
                            label: key,
                        }));
                        const chargePump1 = arrayValue?.find(x => x?.value === gasData?.chargePump);
                        arrayValue.unshift({ value: "", label: "Select" });
                        return [
                            setChargePumpName(arrayValue?.length > 0 && gasData?.chargePump !== "" ? chargePump1?.label : ""),
                            setChargePumpList(arrayValue),
                        ];
                    })
                );
            })
    );
};

const getChPumpList2 = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setCatalogType",
            "gasCalculation/setChargePumpList"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state.tubing.tab1Input)),
            state$.pipe(map((state: RootState) => state.gasCalculations.BasicGasCalculation)),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)
            )
        ),
        concatMap(
            ([actionData, tab1Input, gasData, gasOutput]) => {
                let preTFV = "";
                var GKXVal = gasData?.useOfChgPmp;
                var GKXSelVal = gasData?.chargePumpGKX;
                var noOfGasSeps = +gasData?.noOfGasSeps;
                var selctdGasSep = gasData?.sepSelcted;

                if (GKXVal === "1" && gasOutput !== undefined) {
                    if (GKXSelVal != "") {
                        preTFV = gasOutput?.GKX_TotalFluidVolume?.toString()
                    }
                    else {
                        if (noOfGasSeps > 0) {
                            if (selctdGasSep != "") {
                                if (selctdGasSep?.trim() != "") {
                                    if (noOfGasSeps == 1) {
                                        preTFV = gasOutput?.SP1_TotalFluidVolume?.toString()
                                    }
                                    else if (noOfGasSeps == 2) {
                                        preTFV = gasOutput?.SP2_TotalFluidVolume?.toString()
                                    }
                                    else if (noOfGasSeps == 3) {
                                        preTFV = gasOutput?.SP3_TotalFluidVolume?.toString()
                                    }
                                    else if (noOfGasSeps == 4) {
                                        preTFV = gasOutput?.SP4_TotalFluidVolume?.toString()
                                    }
                                }
                            }
                            else {
                                preTFV = gasOutput?.Intake_TotalFluidVolume?.toString() || ''
                            }
                        }
                        else {
                            preTFV = gasOutput?.Intake_TotalFluidVolume?.toString() || ''
                        }
                    }
                }
                else {
                    if (noOfGasSeps > 0) {
                        if (selctdGasSep != "") {
                            if (selctdGasSep?.trim() != "") {
                                if (noOfGasSeps == 1) {
                                    preTFV = gasOutput?.SP1_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 2) {
                                    preTFV = gasOutput?.SP2_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 3) {
                                    preTFV = gasOutput?.SP3_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 4) {
                                    preTFV = gasOutput?.SP4_TotalFluidVolume?.toString()
                                }
                            }
                        }
                        else {
                            preTFV = gasOutput?.Intake_TotalFluidVolume?.toString()
                        }
                    }
                    else {
                        preTFV = gasOutput?.Intake_TotalFluidVolume?.toString()
                    }
                }
                preTFV = preTFV === undefined ? gasOutput?.Intake_TotalFluidVolume : preTFV;
                const casingOD = tab1Input?.casingOD?.toString();
                const unitSys = tab1Input?.unitSys?.toString();
                const preTFVUnit = tab1Input?.hdnGas_TotalFluidVolume;
                const chargePumpShowAll = tab1Input?.chargePumpShowAll || false;

                const catalogFilter =
                    actionData.type === "tubing/setCatalogType"
                        ? actionData.payload
                        : +tab1Input?.catalogType;

                const payload = {
                    CasingOD: casingOD!,
                    TFV: +preTFV,
                    UnitSys: unitSys?.toString(),
                    TFVUnit: preTFVUnit,
                    catalogFilter: catalogFilter,
                    chargePumpShowAll: chargePumpShowAll,
                } as GetChargePumpListPayload;

                return from(getChargePumpList(payload)).pipe(
                    mergeMap((data) => {
                        const records = data?.ChrgePmpList;
                        if (!records) return [];
                        const arrayValue = Object.keys(records).map((key) => ({
                            value: records[key],
                            label: key,
                        }));
                        const chargePump = arrayValue?.find(x => x?.value === gasData?.chargePump2);
                        arrayValue.unshift({ value: "", label: "Select" });
                        return [
                            setChargePump2Name(arrayValue?.length > 0 && gasData?.chargePump2 !== "" ? chargePump?.label : ""),
                            setChargePumpList2(arrayValue)
                        ];
                    })
                );
            }
        )
    );
};

const getChPumpList3 = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setCatalogType",
            "gasCalculation/setChargePumpList2"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)
            )
        ),
        concatMap(
            ([actionData, tab1Input, gasData, gasOutput]) => {
                let preTFV = "";
                var GKXVal = gasData?.useOfChgPmp;
                var GKXSelVal = gasData?.chargePumpGKX;
                var noOfGasSeps = +gasData?.noOfGasSeps;
                var selctdGasSep = gasData?.sepSelcted;

                if (GKXVal === "1" && gasOutput !== undefined) {
                    if (GKXSelVal != "") {
                        preTFV = gasOutput?.GKX_TotalFluidVolume?.toString()
                    }
                    else {
                        if (noOfGasSeps > 0) {
                            if (selctdGasSep != "") {
                                if (selctdGasSep?.trim() != "") {
                                    if (noOfGasSeps == 1) {
                                        preTFV = gasOutput?.SP1_TotalFluidVolume?.toString()
                                    }
                                    else if (noOfGasSeps == 2) {
                                        preTFV = gasOutput?.SP2_TotalFluidVolume?.toString()
                                    }
                                    else if (noOfGasSeps == 3) {
                                        preTFV = gasOutput?.SP3_TotalFluidVolume?.toString()
                                    }
                                    else if (noOfGasSeps == 4) {
                                        preTFV = gasOutput?.SP4_TotalFluidVolume?.toString()
                                    }
                                }
                            }
                            else {
                                preTFV = gasOutput?.Intake_TotalFluidVolume?.toString() || ''
                            }
                        }
                        else {
                            preTFV = gasOutput?.Intake_TotalFluidVolume?.toString() || ''
                        }
                    }
                }
                else {
                    if (noOfGasSeps > 0) {
                        if (selctdGasSep != "") {
                            if (selctdGasSep?.trim() != "") {
                                if (noOfGasSeps == 1) {
                                    preTFV = gasOutput?.SP1_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 2) {
                                    preTFV = gasOutput?.SP2_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 3) {
                                    preTFV = gasOutput?.SP3_TotalFluidVolume?.toString()
                                }
                                else if (noOfGasSeps == 4) {
                                    preTFV = gasOutput?.SP4_TotalFluidVolume?.toString()
                                }
                            }
                        }
                        else {
                            preTFV = gasOutput?.Intake_TotalFluidVolume?.toString()
                        }
                    }
                    else {
                        preTFV = gasOutput?.Intake_TotalFluidVolume?.toString()
                    }
                }
                preTFV = preTFV === undefined ? gasOutput?.Intake_TotalFluidVolume : preTFV;
                const casingOD = tab1Input?.casingOD?.toString();
                const unitSys = tab1Input?.unitSys?.toString();
                const preTFVUnit = tab1Input?.hdnGas_TotalFluidVolume;
                const chargePumpShowAll = tab1Input?.chargePumpShowAll || false;

                const catalogFilter =
                    actionData.type === "tubing/setCatalogType"
                        ? actionData.payload
                        : +tab1Input?.catalogType;

                const payload = {
                    CasingOD: casingOD,
                    TFV: +preTFV,
                    UnitSys: unitSys?.toString(),
                    TFVUnit: preTFVUnit,
                    catalogFilter: catalogFilter,
                    chargePumpShowAll: chargePumpShowAll,
                } as GetChargePumpListPayload;

                return from(getChargePumpList(payload)).pipe(
                    mergeMap((data) => {
                        const records = data?.ChrgePmpList;
                        if (!records) return [];
                        const arrayValue = Object?.keys(records)?.map((key) => ({
                            value: records[key],
                            label: key,
                        }));
                        const chargePump = arrayValue?.find(x => x?.value === gasData?.chargePump3);
                        arrayValue.unshift({ value: "", label: "Select" });
                        return [
                            setChargePump3Name(arrayValue?.length > 0 && gasData?.chargePump3 !== "" ? chargePump?.label : ""),
                            setChargePumpList3(arrayValue)
                        ];
                    })
                );
            }
        )
    );
};

const getGasHandlersCalculations = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "pump/setPumpInputCalculated",
            "gasCalculation/setTypeOfShaft",
        ),

        withLatestFrom(
            state$.pipe(
                map((state: RootState) => state.gasCalculations.BasicGasCalculation)
            ),
            state$.pipe(
                map((state: RootState) => state.gasCalculations.GasCalculationOutPut)
            ),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.pump?.PumpInput)),
            state$.pipe(
                map((state: RootState) => state?.pump?.PumpInputCalculated)
            ),
            state$.pipe(
                map(
                    (state: RootState) => state?.gasCalculations?.GasFinalCalculatedData
                )
            )
        ),
        concatMap(
            ([
                actionData,
                gasDetails,
                gasoutput,
                tab1Input,
                tab3Input,
                pumpInput,
                pumpInputCalculated,
                finalData,
            ]) => {
                if (gasDetails?.useOfChgPmp === "1" && gasDetails?.chargePumpGKX !== "") {
                    const pumpIdGKX = gasDetails?.chargePumpGKX;
                    let targetFlowRate = 0;
                    const opFreq = tab3Input?.operatngFreq;
                    const speed = +pumpInput?.pump_FullLoadSp || 3500;
                    const fluidVisc = tab3Input?.fluidViscosity;
                    const desiredStages = 0;
                    let tfv = +finalData?.preTFV || +gasoutput?.Intake_TotalFluidVolume || 0;
                    let compSPGr = 0;
                    let flowCorrection = +gasoutput?.GKX_FlowCorrection / 100 || 0;
                    let powerCorrection = +gasoutput?.GKX_PowerCorrection / 100 || 0;
                    let headCorrection = +gasoutput?.GKX_HeadCorrection / 100 || 0;
                    const shaftType = gasDetails?.hdn_GKX_ShaftType||0;
                    const powerGasHandler = gasoutput?.GKX_HPRating || 0;
                    const powerChargePump1 = gasoutput?.CP1_HPRating || 0;
                    const powerChargePump2 = gasoutput?.CP2_HPRating || 0;
                    const powerChargePump3 = gasoutput?.CP3_HPRating || 0;
                    const powerMainPump = pumpInputCalculated?.hPOPPump || 0;
                    const unitSys = +tab1Input?.unitSys || 0;
                    const isGasHandler = true;
                    const fluidViscUnit = tab3Input?.unitFluidViscosityListVal;
                    const noOfGasSeps = gasDetails?.noOfGasSeps;
                    const gasSeperator = gasDetails?.sepSelcted;
                    let specialPumpType = "GasHandler";
                    if (+noOfGasSeps > 0 && gasSeperator) {
                        if (noOfGasSeps === "1") {
                            targetFlowRate = gasoutput?.SP1_TotalFluidVolume;
                            compSPGr = gasoutput?.SP1_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "2") {
                            targetFlowRate = gasoutput?.SP2_TotalFluidVolume;
                            compSPGr = gasoutput?.SP2_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "3") {
                            targetFlowRate = gasoutput?.SP3_TotalFluidVolume;
                            compSPGr = gasoutput?.SP3_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "4") {
                            targetFlowRate = gasoutput?.SP4_TotalFluidVolume;
                            compSPGr = gasoutput?.SP4_FinalComposite_SpGr;
                        }
                    } else {
                        targetFlowRate = gasoutput?.Intake_TotalFluidVolume;
                        compSPGr = gasoutput?.Intake_FinalComposite_SpGr;
                    }

                    const postData_Obj: any = {
                        PumpId: pumpIdGKX,
                        TargetFlowRate: targetFlowRate,
                        OperatingFrequency: opFreq,
                        Speed: speed,
                        FluidViscosity: fluidVisc,
                        DesiredStages: desiredStages,
                        TFV: tfv,
                        CompositeSpGr: compSPGr,
                        FlowCorrection: flowCorrection,
                        HeadCorrection: headCorrection,
                        PowerCorrection: powerCorrection,
                        ShaftType: shaftType,
                        PowerGasHandler: powerGasHandler,
                        PowerChargePump1: powerChargePump1,
                        PowerChargePump2: powerChargePump2,
                        PowerChargePump3: powerChargePump3,
                        PowerMainPump: powerMainPump,
                        UnitSystem: unitSys,
                        IsGasHandler: isGasHandler,
                        ViscosityUnit: fluidViscUnit,
                        SpecialPumpType: specialPumpType,
                    };

                    return from(getSpecialPumpsCalculations(postData_Obj)).pipe(
                        map((result) => {
                            const gkxCalculationData = result;
                            return gkxCalculationData;
                        }),
                        mergeMap((gkxCalculationData) => [
                            setGKXCalculationData(gkxCalculationData),
                        ])
                    );
                }

                return of({ type: "gasHandlerCalculation/setGKXCalculationData", payload: {} });
            }
        )
    );
};

const fetchEquipmentsHandler = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/fetchEquipmentsGasHandler"),
        withLatestFrom(
            state$.pipe(
                map(
                    (state: RootState) =>
                        state?.gasCalculations?.BasicGasCalculation?.chargePumpGKX
                )
            ),
            state$.pipe(map((state: RootState) => state?.gasHandler?.gasHandlerPumpName)),
            state$.pipe(
                map((state: RootState) => state?.tubing?.tab1Input?.catalogType)
            )
        ),
        switchMap(([actionData, selectedGasHandler, pumpName, equipmentType]) => {
            if (selectedGasHandler === undefined) {
                return [
                    setGasHandlerEquipmentsDropdown([]),
                ];
            } else if (selectedGasHandler !== "" && pumpName !== "") {
                const payload = {
                    pumpName: pumpName,
                    catalogFilter: equipmentType,
                };
                return from(fetchEquipmentsForHandler(payload)).pipe(
                    mergeMap((data) => {
                        if (data.length === 0) {
                            return [
                                setGasNotification({
                                    show: true,
                                    message: "There are no co-related Equipments for this Gas Handler.",
                                    type: "info",
                                }),
                                setShowHideGasHandlerEquipment(false),
                            ]
                        }
                        return [
                            setGasNotification({
                                show: false,
                                message: "",
                                type: "",
                            }),
                            setShowHideGasHandlerEquipment(true),
                            setGasHandlerEquipmentsDropdown(data),
                        ];
                    })
                );
            }
            return EMPTY;
        })
    );
};

const getgkxCapacityGraphData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "gasHandlerCalculation/setGKXCalculationData"
        ),
        withLatestFrom(
            state$.pipe(
                map((state: RootState) => state.gasCalculations.BasicGasCalculation)
            ),
            state$.pipe(
                map((state: RootState) => state.gasCalculations.GasCalculationOutPut)
            ),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(
                map(
                    (state: RootState) => state?.gasCalculations?.GasFinalCalculatedData
                )
            )
        ),
        concatMap(
            ([
                actionData,
                gasDetails,
                gasOutputs,
                tubingData,
                wellData,
                fluidData,
            ]) => {
                if (gasDetails?.chargePumpGKX !== "") {
                    const pumpId = gasDetails?.chargePumpGKX;
                    const unitSystem = +tubingData?.unitSys;
                    const fluidViscosity = +(fluidData?.fluidViscosity || 0);
                    const operatingFrequency = +(fluidData?.operatngFreq || 0);
                    const motorSpeed = 3500;
                    const fluidViscosityUnit = +(fluidData?.unitFluidViscosityListVal || 0);
                    const finalTDH = actionData?.payload?.finalTDH;
                    const flowCorrection = (gasOutputs?.GKX_FlowCorrection) / 100;
                    const headCorrection = (gasOutputs?.GKX_HeadCorrection) / 100;
                    const powerCorrection = (gasOutputs?.GKX_PowerCorrection) / 100;

                    const productionRateUnit = +(wellData?.unitProductionRateListVal || 0);
                    let productionRate = 0;
                    let fluidSpGravity = 0;
                    if (+gasDetails?.noOfGasSeps > 0 && gasDetails?.sepSelcted) {
                        const noOfGasSeps = +(gasDetails?.noOfGasSeps || 0);
                        if (noOfGasSeps === 1) {
                            productionRate = +(gasOutputs?.SP1_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP1_FinalComposite_SpGr || 0);
                        } else if (noOfGasSeps === 2) {
                            productionRate = +(gasOutputs?.SP2_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP2_FinalComposite_SpGr || 0);
                        } else if (noOfGasSeps === 3) {
                            productionRate = +(gasOutputs?.SP3_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP3_FinalComposite_SpGr || 0);
                        } else if (noOfGasSeps === 4) {
                            productionRate = +(gasOutputs?.SP4_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP4_FinalComposite_SpGr || 0);
                        }
                    } else {
                        productionRate = +(gasOutputs?.Intake_TotalFluidVolume || 0);
                        fluidSpGravity = +(gasOutputs?.Intake_FinalComposite_SpGr || 0);
                    }

                    return from(
                        getGKXCapacityGraphData({
                            pumpId,
                            flowCorrectionFactor: flowCorrection,
                            headCorrectionFactor: headCorrection,
                            powerCorrectionFactor: powerCorrection,
                            fluidSpGravity,
                            fluidViscosity,
                            motorSpeed,
                            productionRate,
                            unitSystem,
                            productionRateUnit,
                            operatingFreq: operatingFrequency,
                            fluidViscosityUnit,
                            finalTDH,
                        })
                    ).pipe(mergeMap((data) => {
                        return [setGKXPumpCapcityGraphData(data)]
                    }));
                }
                return EMPTY;
            }
        )
    );
};

const getCP1Calculations = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "pump/setPumpInputCalculated",
            "gasCalculation/setTypeOfShaft1",
        ),
        withLatestFrom(
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)
            ),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)
            ),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.pump?.PumpInput)),
            state$.pipe(
                map((state: RootState) => state?.pump?.PumpInputCalculated)
            ),
            state$.pipe(
                map(
                    (state: RootState) => state?.gasCalculations?.GasFinalCalculatedData
                )
            )
        ),
        concatMap(
            ([
                actionData,
                gasDetails,
                gasoutput,
                tab1Input,
                tab3Input,
                pumpInput,
                pumpInputCalculated,
                finalData,
            ]) => {
                if (gasDetails?.useOfChgPmpNew === "1" && gasDetails?.chargePump) {
                    const isUrl = window?.location?.href?.includes("templateID");
                    const pumpIdGKX = gasDetails?.chargePump;
                    let targetFlowRate = 0;
                    const opFreq = tab3Input?.operatngFreq;
                    const speed = +pumpInput?.pump_FullLoadSp || 3500;
                    const fluidVisc = tab3Input?.fluidViscosity;
                    const desiredStages = gasDetails?.chargePumpDesrdStge || 0;
                    let tfv = +finalData?.preTFV || +gasoutput?.Intake_TotalFluidVolume || 0;
                    let compSPGr = 0;
                    let flowCorrection = isUrl && desiredStages === 0 ? 0 : +gasoutput?.CP1_FlowCorrection / 100 || 0;
                    let powerCorrection = isUrl && desiredStages === 0 ? 0 : +gasoutput?.CP1_PowerCorrection / 100 || 0;
                    let headCorrection = isUrl && desiredStages === 0 ? 0 :+gasoutput?.CP1_HeadCorrection / 100 || 0;
                    const shaftType = +gasDetails?.hdn_ChargePump1_ShaftType || 0;
                    const powerGasHandler = gasoutput?.GKX_HPRating || 0;
                    const powerChargePump1 = gasoutput?.CP1_HPRating || 0;
                    const powerChargePump2 = gasoutput?.CP2_HPRating || 0;
                    const powerChargePump3 = gasoutput?.CP3_HPRating || 0;
                    const powerMainPump = pumpInputCalculated?.hPOPPump || 0;
                    const unitSys = +tab1Input?.unitSys || 0;
                    const isGasHandler = false;
                    const fluidViscUnit = tab3Input?.unitFluidViscosityListVal;

                    const noOfGasSeps = gasDetails?.noOfGasSeps;
                    const gasSeperator = gasDetails?.sepSelcted;
                    let specialPumpType = "ChargePump1";

                    if (gasDetails?.useOfChgPmp && gasDetails?.chargePumpGKX) {
                        targetFlowRate = gasoutput?.GKX_TotalFluidVolume;
                        compSPGr = gasoutput?.GKX_FinalComposite_SpGr;
                    } else if (+noOfGasSeps > 0 && gasSeperator) {
                        if (noOfGasSeps === "1") {
                            targetFlowRate = gasoutput?.SP1_TotalFluidVolume;
                            compSPGr = gasoutput?.SP1_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "2") {
                            targetFlowRate = gasoutput?.SP2_TotalFluidVolume;
                            compSPGr = gasoutput?.SP2_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "3") {
                            targetFlowRate = gasoutput?.SP3_TotalFluidVolume;
                            compSPGr = gasoutput?.SP3_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "4") {
                            targetFlowRate = gasoutput?.SP4_TotalFluidVolume;
                            compSPGr = gasoutput?.SP4_FinalComposite_SpGr;
                        }
                    } else {
                        targetFlowRate = gasoutput?.Intake_TotalFluidVolume;
                        compSPGr = gasoutput?.Intake_FinalComposite_SpGr;
                    }

                    const postData_Obj: any = {
                        PumpId: pumpIdGKX,
                        TargetFlowRate: targetFlowRate,
                        OperatingFrequency: opFreq,
                        Speed: speed,
                        FluidViscosity: fluidVisc,
                        DesiredStages: desiredStages,
                        TFV: tfv,
                        CompositeSpGr: compSPGr,
                        FlowCorrection: flowCorrection,
                        HeadCorrection: headCorrection,
                        PowerCorrection: powerCorrection,
                        ShaftType: shaftType,
                        PowerGasHandler: powerGasHandler,
                        PowerChargePump1: powerChargePump1,
                        PowerChargePump2: powerChargePump2,
                        PowerChargePump3: powerChargePump3,
                        PowerMainPump: powerMainPump,
                        UnitSystem: unitSys,
                        IsGasHandler: isGasHandler,
                        ViscosityUnit: fluidViscUnit,
                        SpecialPumpType: specialPumpType,
                    };

                    return from(getSpecialPumpsCalculations(postData_Obj)).pipe(
                        map((result) => {
                            const cp1CalculationData = result;
                            return cp1CalculationData;
                        }),
                        mergeMap((cp1CalculationData) => {
                            return [
                                setCP1CalculationData(cp1CalculationData),
                            ]
                        })
                    );
                }
                return of({ type: "gasHandlerCalculation/setCP1CalculationData", payload: {} });
            }
        )
    );
};

const getCP1CapacityGraphData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasHandlerCalculation/setCP1CalculationData"),
        withLatestFrom(
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)
            ),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)
            ),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
        ),
        concatMap(
            ([
                actionData,
                gasDetails,
                gasOutputs,
                tubingData,
                wellData,
                fluidData,
            ]) => {
                if (gasDetails?.useOfChgPmpNew === "1" && gasDetails?.chargePump !== "" && gasOutputs) {
                    const pumpId = gasDetails?.chargePump;
                    const noOfStages = +(gasDetails?.chargePumpDesrdStge || 0);
                    const unitSystem = tubingData?.unitSys ?? 0;
                    const fluidViscosity = +(fluidData?.fluidViscosity || 0);
                    const operatingFrequency = +(fluidData?.operatngFreq || 0);
                    const motorSpeed = 3500;
                    const fluidViscosityUnit = +(fluidData?.unitFluidViscosityListVal || 0);
                    const finalTDH = +(actionData?.payload?.finalTDH || 0);
                    const flowCorrection = +(gasOutputs?.CP1_FlowCorrection / 100);
                    const headCorrection = +(gasOutputs?.CP1_HeadCorrection / 100);
                    const powerCorrection = +(gasOutputs?.CP1_PowerCorrection / 100);

                    const productionRateUnit = +(wellData?.unitProductionRateListVal || 0);
                    let productionRate = 0;
                    let fluidSpGravity = 0;
                    if (+gasDetails?.useOfChgPmp && gasDetails?.chargePumpGKX != null) {
                        productionRate = +(gasOutputs?.GKX_TotalFluidVolume || 0);
                        fluidSpGravity = +(gasOutputs?.GKX_FinalComposite_SpGr || 0);
                    }
                    else if (+gasDetails?.noOfGasSeps > 0 && gasDetails?.sepSelcted) {
                        const noOfGasSeps = +(gasDetails?.noOfGasSeps || 0);
                        if (noOfGasSeps === 1) {
                            productionRate = +(gasOutputs?.SP1_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP1_FinalComposite_SpGr || 0);
                        }
                        else if (noOfGasSeps === 2) {
                            productionRate = +(gasOutputs?.SP2_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP2_FinalComposite_SpGr || 0);
                        }
                        else if (noOfGasSeps === 3) {
                            productionRate = +(gasOutputs?.SP3_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP3_FinalComposite_SpGr || 0);
                        }
                        else if (noOfGasSeps === 4) {
                            productionRate = +(gasOutputs?.SP4_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP4_FinalComposite_SpGr || 0);
                        }
                    } else {
                        productionRate = +(gasOutputs?.Intake_TotalFluidVolume || 0);
                        fluidSpGravity = +(gasOutputs?.Intake_FinalComposite_SpGr || 0);
                    }

                    return from(
                        GetCPCapacityGraphData({
                            pumpId,
                            noOfStages: noOfStages,
                            flowCorrectionFactor: flowCorrection,
                            headCorrectionFactor: headCorrection,
                            powerCorrectionFactor: powerCorrection,
                            fluidSpGravity,
                            fluidViscosity,
                            motorSpeed,
                            productionRate,
                            unitSystem,
                            productionRateUnit,
                            operatingFreq: operatingFrequency,
                            fluidViscosityUnit,
                            finalTDH,
                        })
                    ).pipe(
                        mergeMap((data) => {
                            return [setCP1GraphData(data)]
                        }),
                        catchError((error) => {
                            return of(console.log(error, "cp1 graph error"));
                        }),
                    );
                }
                return EMPTY;
            }
        )
    );
};

const getCP2Calculations = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "pump/setPumpInputCalculated",
            "gasCalculation/setTypeOfShaft2"
        ),
        withLatestFrom(
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)
            ),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)
            ),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.pump?.PumpInput)),
            state$.pipe(
                map((state: RootState) => state?.pump?.PumpInputCalculated)
            ),
            state$.pipe(
                map(
                    (state: RootState) => state?.gasCalculations?.GasFinalCalculatedData
                )
            )
        ),
        concatMap(
            ([
                actionData,
                gasDetails,
                gasoutput,
                tab1Input,
                tab3Input,
                pumpInput,
                pumpInputCalculated,
                finalData,
            ]) => {
                if (gasDetails?.useOfChgPmpNew === "1" && gasDetails?.chargePump2) {
                    const isUrl = window?.location?.href?.includes("templateID");
                    const pumpIdGKX = gasDetails?.chargePump2;
                    let targetFlowRate = 0;
                    const opFreq = tab3Input?.operatngFreq;
                    const speed = +pumpInput?.pump_FullLoadSp || 3500;
                    const fluidVisc = tab3Input?.fluidViscosity;
                    const desiredStages = gasDetails?.chargePumpDesrdStge2 || 0;
                    let tfv = +finalData?.preTFV || +gasoutput?.Intake_TotalFluidVolume || 0;
                    let compSPGr = 0;
                    let flowCorrection = isUrl && desiredStages === 0 ? 0 : +gasoutput?.CP2_FlowCorrection / 100 || 0;
                    let powerCorrection = isUrl && desiredStages === 0 ? 0 : +gasoutput?.CP2_PowerCorrection / 100 || 0;
                    let headCorrection = isUrl && desiredStages === 0 ? 0 : +gasoutput?.CP2_HeadCorrection / 100 || 0;
                    const shaftType = gasDetails?.hdn_ChargePump2_ShaftType || 0;
                    const powerGasHandler = gasoutput?.GKX_HPRating || 0;
                    const powerChargePump1 = gasoutput?.CP1_HPRating || 0;
                    const powerChargePump2 = gasoutput?.CP2_HPRating || 0;
                    const powerChargePump3 = gasoutput?.CP3_HPRating || 0;
                    const powerMainPump = pumpInputCalculated?.hPOPPump || 0;
                    const unitSys = +tab1Input?.unitSys || 0;
                    const isGasHandler = false;
                    const fluidViscUnit = tab3Input?.unitFluidViscosityListVal;

                    const noOfGasSeps = gasDetails?.noOfGasSeps;
                    const gasSeperator = gasDetails?.sepSelcted;
                    let specialPumpType = "ChargePump2";
                    if (gasDetails?.chargePump) {
                        targetFlowRate = gasoutput?.CP1_TotalFluidVolume;
                        compSPGr = gasoutput?.CP1_FinalComposite_SpGr;
                    } else if (gasDetails?.useOfChgPmp && gasDetails?.chargePumpGKX) {
                        targetFlowRate = gasoutput?.GKX_TotalFluidVolume;
                        compSPGr = gasoutput?.GKX_FinalComposite_SpGr;
                    } else if (+noOfGasSeps > 0 && gasSeperator) {
                        if (noOfGasSeps === "1") {
                            targetFlowRate = gasoutput?.SP1_TotalFluidVolume;
                            compSPGr = gasoutput?.SP1_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "2") {
                            targetFlowRate = gasoutput?.SP2_TotalFluidVolume;
                            compSPGr = gasoutput?.SP2_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "3") {
                            targetFlowRate = gasoutput?.SP3_TotalFluidVolume;
                            compSPGr = gasoutput?.SP3_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "4") {
                            targetFlowRate = gasoutput?.SP4_TotalFluidVolume;
                            compSPGr = gasoutput?.SP4_FinalComposite_SpGr;
                        }
                    } else {
                        targetFlowRate = gasoutput?.Intake_TotalFluidVolume;
                        compSPGr = gasoutput?.Intake_FinalComposite_SpGr;
                    }

                    const postData_Obj: any = {
                        PumpId: pumpIdGKX,
                        TargetFlowRate: targetFlowRate,
                        OperatingFrequency: opFreq,
                        Speed: speed,
                        FluidViscosity: fluidVisc,
                        DesiredStages: desiredStages,
                        TFV: tfv,
                        CompositeSpGr: compSPGr,
                        FlowCorrection: flowCorrection,
                        HeadCorrection: headCorrection,
                        PowerCorrection: powerCorrection,
                        ShaftType: shaftType,
                        PowerGasHandler: powerGasHandler,
                        PowerChargePump1: powerChargePump1,
                        PowerChargePump2: powerChargePump2,
                        PowerChargePump3: powerChargePump3,
                        PowerMainPump: powerMainPump,
                        UnitSystem: unitSys,
                        IsGasHandler: isGasHandler,
                        ViscosityUnit: fluidViscUnit,
                        SpecialPumpType: specialPumpType,
                    };

                    return from(getSpecialPumpsCalculations(postData_Obj)).pipe(
                        map((result) => {
                            const cp2CalculationData = result;
                            return cp2CalculationData;
                        }),
                        mergeMap((cp1CalculationData) => [
                            setCP2CalculationData(cp1CalculationData),
                        ])
                    );
                }
                return of({ type: "gasHandlerCalculation/setCP2CalculationData", payload: {} });
            }
        )
    );
};

const getCP2CapacityGraphData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasHandlerCalculation/setCP2CalculationData"),
        withLatestFrom(
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)
            ),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)
            ),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
        ),
        concatMap(
            ([
                actionData,
                gasDetails,
                gasOutputs,
                tubingData,
                wellData,
                fluidData,
            ]) => {
                if (gasDetails?.useOfChgPmpNew === "1" && gasDetails?.chargePump2 !== "" && gasOutputs) {
                    const pumpId = gasDetails?.chargePump2;
                    const noOfStages = +(gasDetails?.chargePumpDesrdStge2 || 0);
                    const unitSystem = tubingData?.unitSys ?? 0;
                    const fluidViscosity = +(fluidData?.fluidViscosity || 0);
                    const operatingFrequency = +(fluidData?.operatngFreq || 0);
                    const motorSpeed = 3500;
                    const fluidViscosityUnit = +(fluidData?.unitFluidViscosityListVal || 0);
                    const finalTDH = +(actionData?.payload?.finalTDH || 0);
                    const flowCorrection = +(gasOutputs?.CP2_FlowCorrection / 100);
                    const headCorrection = +(gasOutputs?.CP2_HeadCorrection / 100);
                    const powerCorrection = +(gasOutputs?.CP2_PowerCorrection / 100);

                    const productionRateUnit = +(wellData?.unitProductionRateListVal || 0);
                    let productionRate = 0;
                    let fluidSpGravity = 0;
                    if (gasDetails?.useOfChgPmpNew === "1" && gasDetails?.chargePump !== "" && +gasDetails?.chargePumpDesrdStge > 0) {
                        productionRate = +(gasOutputs?.CP1_TotalFluidVolume || 0);
                        fluidSpGravity = +(gasOutputs?.CP1_FinalComposite_SpGr || 0);
                    }
                    else if (+gasDetails?.useOfChgPmp && gasDetails?.chargePumpGKX != null) {
                        productionRate = +(gasOutputs?.GKX_TotalFluidVolume || 0);
                        fluidSpGravity = +(gasOutputs?.GKX_FinalComposite_SpGr || 0);
                    }
                    else if (+gasDetails?.noOfGasSeps > 0 && gasDetails?.sepSelcted) {
                        const noOfGasSeps = +(gasDetails?.noOfGasSeps || 0);
                        if (noOfGasSeps === 1) {
                            productionRate = +(gasOutputs?.SP1_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP1_FinalComposite_SpGr || 0);
                        }
                        else if (noOfGasSeps === 2) {
                            productionRate = +(gasOutputs?.SP2_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP2_FinalComposite_SpGr || 0);
                        }
                        else if (noOfGasSeps === 3) {
                            productionRate = +(gasOutputs?.SP3_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP3_FinalComposite_SpGr || 0);
                        }
                        else if (noOfGasSeps === 4) {
                            productionRate = +(gasOutputs?.SP4_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP4_FinalComposite_SpGr || 0);
                        }
                    } else {
                        productionRate = +(gasOutputs?.Intake_TotalFluidVolume || 0);
                        fluidSpGravity = +(gasOutputs?.Intake_FinalComposite_SpGr || 0);
                    }

                    return from(
                        GetCPCapacityGraphData({
                            pumpId,
                            noOfStages,
                            flowCorrectionFactor: flowCorrection,
                            headCorrectionFactor: headCorrection,
                            powerCorrectionFactor: powerCorrection,
                            fluidSpGravity,
                            fluidViscosity,
                            motorSpeed,
                            productionRate,
                            unitSystem,
                            productionRateUnit,
                            operatingFreq: operatingFrequency,
                            fluidViscosityUnit,
                            finalTDH,
                        })
                    ).pipe(
                        mergeMap((data) => {
                            return [setCP2GraphData(data)]
                        }),
                        catchError((error) => {
                            return of(console.log(error, "cp2 graph error"));
                        }),
                    );
                }
                return EMPTY;
            }
        )
    );
};

const getCP3Calculations = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "pump/setPumpInputCalculated",
            "gasCalculation/setTypeOfShaft3"
        ),
        withLatestFrom(
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)
            ),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)
            ),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.pump?.PumpInput)),
            state$.pipe(
                map((state: RootState) => state?.pump?.PumpInputCalculated)
            ),
            state$.pipe(
                map(
                    (state: RootState) => state?.gasCalculations?.GasFinalCalculatedData
                )
            )
        ),
        concatMap(
            ([
                actionData,
                gasDetails,
                gasoutput,
                tab1Input,
                tab3Input,
                pumpInput,
                pumpInputCalculated,
                finalData,
            ]) => {
                if (gasDetails?.useOfChgPmpNew === "1" && gasDetails?.chargePump3) {
                    const isUrl = window?.location?.href?.includes("templateID");
                    const pumpIdGKX = gasDetails?.chargePump3;
                    let targetFlowRate = 0;
                    const opFreq = tab3Input?.operatngFreq;
                    const speed = +pumpInput?.pump_FullLoadSp || 3500;
                    const fluidVisc = tab3Input?.fluidViscosity;
                    const desiredStages = gasDetails?.chargePumpDesrdStge3 || 0;
                    let tfv =
                        +finalData?.preTFV || +gasoutput?.Intake_TotalFluidVolume || 0;
                    let compSPGr = 0;
                    let flowCorrection = isUrl && desiredStages === 0 ? 0 : +gasoutput?.CP3_FlowCorrection / 100 || 0;
                    let powerCorrection = isUrl && desiredStages === 0 ? 0 : +gasoutput?.CP3_PowerCorrection / 100 || 0;
                    let headCorrection = isUrl && desiredStages === 0 ? 0 : +gasoutput?.CP3_HeadCorrection / 100 || 0;
                    const shaftType = gasDetails?.hdn_ChargePump3_ShaftType || 0;
                    const powerGasHandler = gasoutput?.GKX_HPRating || 0;
                    const powerChargePump1 = gasoutput?.CP1_HPRating || 0;
                    const powerChargePump2 = gasoutput?.CP2_HPRating || 0;
                    const powerChargePump3 = gasoutput?.CP3_HPRating || 0;
                    const powerMainPump = pumpInputCalculated?.hPOPPump || 0;
                    const unitSys = +tab1Input?.unitSys || 0;
                    const isGasHandler = false;
                    const fluidViscUnit = tab3Input?.unitFluidViscosityListVal;

                    const noOfGasSeps = gasDetails?.noOfGasSeps;
                    const gasSeperator = gasDetails?.sepSelcted;
                    let specialPumpType = "ChargePump3";
                    if (gasDetails?.chargePump2) {
                        targetFlowRate = gasoutput?.CP2_TotalFluidVolume;
                        compSPGr = gasoutput?.CP2_FinalComposite_SpGr;
                    } else if (gasDetails?.chargePump) {
                        targetFlowRate = gasoutput?.CP1_TotalFluidVolume;
                        compSPGr = gasoutput?.CP1_FinalComposite_SpGr;
                    } else if (gasDetails?.useOfChgPmp && gasDetails?.chargePumpGKX) {
                        targetFlowRate = gasoutput?.GKX_TotalFluidVolume;
                        compSPGr = gasoutput?.GKX_FinalComposite_SpGr;
                    } else if (+noOfGasSeps > 0 && gasSeperator) {
                        if (noOfGasSeps === "1") {
                            targetFlowRate = gasoutput?.SP1_TotalFluidVolume;
                            compSPGr = gasoutput?.SP1_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "2") {
                            targetFlowRate = gasoutput?.SP2_TotalFluidVolume;
                            compSPGr = gasoutput?.SP2_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "3") {
                            targetFlowRate = gasoutput?.SP3_TotalFluidVolume;
                            compSPGr = gasoutput?.SP3_FinalComposite_SpGr;
                        } else if (noOfGasSeps === "4") {
                            targetFlowRate = gasoutput?.SP4_TotalFluidVolume;
                            compSPGr = gasoutput?.SP4_FinalComposite_SpGr;
                        }
                    } else {
                        targetFlowRate = gasoutput?.Intake_TotalFluidVolume;
                        compSPGr = gasoutput?.Intake_FinalComposite_SpGr;
                    }

                    const postData_Obj: any = {
                        PumpId: pumpIdGKX,
                        TargetFlowRate: targetFlowRate,
                        OperatingFrequency: opFreq,
                        Speed: speed,
                        FluidViscosity: fluidVisc,
                        DesiredStages: desiredStages,
                        TFV: tfv,
                        CompositeSpGr: compSPGr,
                        FlowCorrection: flowCorrection,
                        HeadCorrection: headCorrection,
                        PowerCorrection: powerCorrection,
                        ShaftType: shaftType,
                        PowerGasHandler: powerGasHandler,
                        PowerChargePump1: powerChargePump1,
                        PowerChargePump2: powerChargePump2,
                        PowerChargePump3: powerChargePump3,
                        PowerMainPump: powerMainPump,
                        UnitSystem: unitSys,
                        IsGasHandler: isGasHandler,
                        ViscosityUnit: fluidViscUnit,
                        SpecialPumpType: specialPumpType,
                    };

                    return from(getSpecialPumpsCalculations(postData_Obj)).pipe(
                        map((result) => {
                            const cp3CalculationData = result;
                            return cp3CalculationData;
                        }),
                        mergeMap((cp1CalculationData) => [
                            setCP3CalculationData(cp1CalculationData),
                        ])
                    );
                }
                return of({ type: "gasHandlerCalculation/setCP3CalculationData", payload: {} });
            })
    );
};

const getCP3CapacityGraphData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasHandlerCalculation/setCP3CalculationData"),
        withLatestFrom(
            state$.pipe(
                map((state: RootState) => state.gasCalculations.BasicGasCalculation)
            ),
            state$.pipe(
                map((state: RootState) => state.gasCalculations.GasCalculationOutPut)
            ),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
        ),
        concatMap(
            ([
                actionData,
                gasDetails,
                gasOutputs,
                tubingData,
                wellData,
                fluidData,
            ]) => {
                if (gasDetails?.useOfChgPmpNew === "1" && gasDetails?.chargePump3 !== "" && gasOutputs) {
                    const pumpId = gasDetails?.chargePump3;
                    const noOfStages = +(gasDetails?.chargePumpDesrdStge3 || 0);
                    const unitSystem = tubingData?.unitSys ?? 0;
                    const fluidViscosity = +(fluidData?.fluidViscosity || 0);
                    const operatingFrequency = +(fluidData?.operatngFreq || 0);
                    const motorSpeed = 3500;
                    const fluidViscosityUnit = +(fluidData?.unitFluidViscosityListVal || 0);
                    const finalTDH = +(actionData?.payload?.finalTDH || 0);
                    const flowCorrection = +(gasOutputs?.CP3_FlowCorrection / 100);
                    const headCorrection = +(gasOutputs?.CP3_HeadCorrection / 100);
                    const powerCorrection = +(gasOutputs?.CP3_PowerCorrection / 100);

                    const productionRateUnit = +(wellData?.unitProductionRateListVal || 0);
                    let productionRate = 0;
                    let fluidSpGravity = 0;
                    if (+gasDetails?.useOfChgPmpNew && gasDetails?.chargePump2 && +gasDetails?.chargePumpDesrdStge2 > 0) {
                        productionRate = +(gasOutputs?.CP2_TotalFluidVolume || 0);
                        fluidSpGravity = +(gasOutputs?.CP2_FinalComposite_SpGr || 0);
                    }
                    else if (+gasDetails?.useOfChgPmpNew && gasDetails?.chargePump && +gasDetails?.chargePumpDesrdStge > 0) {
                        productionRate = +(gasOutputs?.CP1_TotalFluidVolume || 0);
                        fluidSpGravity = +(gasOutputs?.CP1_FinalComposite_SpGr || 0);
                    }
                    else if (+gasDetails?.useOfChgPmp && gasDetails?.chargePumpGKX != null) {
                        productionRate = +(gasOutputs?.GKX_TotalFluidVolume || 0);
                        fluidSpGravity = +(gasOutputs?.GKX_FinalComposite_SpGr || 0);
                    }
                    else if (+gasDetails?.noOfGasSeps > 0 && gasDetails?.sepSelcted) {
                        const noOfGasSeps = +(gasDetails?.noOfGasSeps || 0);
                        if (noOfGasSeps == 1) {
                            productionRate = +(gasOutputs?.SP1_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP1_FinalComposite_SpGr || 0);
                        }
                        else if (noOfGasSeps == 2) {
                            productionRate = +(gasOutputs?.SP2_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP2_FinalComposite_SpGr || 0);
                        }
                        else if (noOfGasSeps == 3) {
                            productionRate = +(gasOutputs?.SP3_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP3_FinalComposite_SpGr || 0);
                        }
                        else if (noOfGasSeps == 4) {
                            productionRate = +(gasOutputs?.SP4_TotalFluidVolume || 0);
                            fluidSpGravity = +(gasOutputs?.SP4_FinalComposite_SpGr || 0);
                        }
                    } else {
                        productionRate = +(gasOutputs?.Intake_TotalFluidVolume || 0);
                        fluidSpGravity = +(gasOutputs?.Intake_FinalComposite_SpGr || 0);
                    }

                    return from(
                        GetCPCapacityGraphData({
                            pumpId,
                            noOfStages,
                            flowCorrectionFactor: flowCorrection,
                            headCorrectionFactor: headCorrection,
                            powerCorrectionFactor: powerCorrection,
                            fluidSpGravity,
                            fluidViscosity,
                            motorSpeed,
                            productionRate,
                            unitSystem,
                            productionRateUnit,
                            operatingFreq: operatingFrequency,
                            fluidViscosityUnit,
                            finalTDH,
                        })
                    ).pipe(
                        mergeMap((data) => {
                            return [setCP3GraphData(data)]
                        }),
                        catchError((error) => {
                            return of(console.log(error, "cp3 graph error"));
                        }),
                    );
                }
                return EMPTY;
            }
        )
    );
};

const fetchEquipmentsChargePumpOne = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/fetchEquipmentsChargePump"),
        withLatestFrom(
            state$.pipe(
                map(
                    (state: RootState) =>
                        state?.gasCalculations?.BasicGasCalculation?.chargePump
                )
            ),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.chargePumpName)
            ),
            state$.pipe(
                map((state: RootState) => state?.tubing?.tab1Input?.catalogType)
            )
        ),
        switchMap(([actionData, selectedChargePumpOne, chargePump, equipmentType]) => {
            if (selectedChargePumpOne === undefined) {
                return [setExistedSRGasPump1Equipments([])];
            } else if (selectedChargePumpOne !== "" && chargePump !== undefined) {
                const payload: any = {
                    pump: chargePump,
                    catalogFilter: equipmentType,
                };
                return from(GetEquipmentsForChargePumps(payload)).pipe(
                    mergeMap((data) => {
                        if (data?.length === 0) {
                            return [
                                setGasNotification({
                                    show: true,
                                    message: "There are no co-related Equipments for this Charge Pump One.",
                                    type: "info",
                                }),
                                setShowHideSRGasPump1Equipment(false),
                                setChargePump1EquipmentsDropdown([])
                            ]
                        }
                        return [
                            setGasNotification({
                                show: false,
                                message: "",
                                type: "",
                            }),
                            setShowHideSRGasPump1Equipment(true),
                            setChargePump1EquipmentsDropdown(data)
                        ]
                    })
                );
            }
            return EMPTY;
        })
    );
};

const fetchEquipmentsChargePumpTwo = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/fetchEquipmentsChargePump2"),
        withLatestFrom(
            state$.pipe(
                map(
                    (state: RootState) =>
                        state?.gasCalculations?.BasicGasCalculation?.chargePump2
                )
            ),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.chargePump2Name)
            ),
            state$.pipe(
                map((state: RootState) => state?.tubing?.tab1Input?.catalogType)
            )
        ),
        switchMap(([actionData, selectedChargePumpTwo, chargePump2, equipmentType]) => {
            if (selectedChargePumpTwo === undefined) {
                return [setExistedSRGasPump2Equipments([])];
            } else if (selectedChargePumpTwo !== "" && chargePump2 !== undefined) {
                const payload: any = {
                    pump: chargePump2,
                    catalogFilter: equipmentType,
                };
                return from(GetEquipmentsForChargePumps(payload)).pipe(
                    mergeMap((data) => {
                        if (data?.length === 0) {
                            return [
                                setGasNotification({
                                    show: true,
                                    message: "There are no co-related Equipments for this Charge Pump One.",
                                    type: "info",
                                }),
                                setShowHideSRGasPump2Equipment(false),
                                setChargePump2EquipmentsDropdown([])
                            ]
                        }
                        return [
                            setGasNotification({
                                show: false,
                                message: "",
                                type: "",
                            }),
                            setShowHideSRGasPump2Equipment(true),
                            setChargePump2EquipmentsDropdown(data),
                        ];
                    })
                );
            }
            return EMPTY;
        })
    );
};

const fetchEquipmentsChargePumpThree = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/fetchEquipmentsChargePump3"),
        withLatestFrom(
            state$.pipe(
                map(
                    (state: RootState) =>
                        state?.gasCalculations?.BasicGasCalculation?.chargePump3
                )
            ),
            state$.pipe(
                map((state: RootState) => state?.gasCalculations?.chargePump3Name)
            ),
            state$.pipe(
                map((state: RootState) => state?.tubing?.tab1Input?.catalogType)
            )
        ),
        switchMap(([actionData, selectedChargePumpThreee, chargePump3, equipmentType]) => {
            if (selectedChargePumpThreee === undefined) {
                return [setExistedSRGasPump3Equipments([])];
            } else if (selectedChargePumpThreee !== "" && chargePump3 !== undefined) {
                const payload: any = {
                    pump: chargePump3,
                    catalogFilter: equipmentType,
                };
                return from(GetEquipmentsForChargePumps(payload)).pipe(
                    mergeMap((data: any) => {
                        if (data?.length === 0) {
                            return [
                                setGasNotification({
                                    show: true,
                                    message: "There are no co-related Equipments for this Charge Pump Three.",
                                    type: "info",
                                }),
                                setShowHideSRGasPump3Equipment(false),
                                setChargePump3EquipmentsDropdown([]),
                            ]
                        }
                        return [
                            setGasNotification({
                                show: false,
                                message: "",
                                type: "",
                            }),
                            setShowHideSRGasPump3Equipment(true),
                            setChargePump3EquipmentsDropdown(data),
                        ];
                    })
                );
            }
            return EMPTY;
        })
    );
};

export const gasHandlerEpic = combineEpics(
    getGKXList,
    getChPumpList,
    getChPumpList2,
    getChPumpList3,
    getGasHandlersCalculations,
    getCP1Calculations,
    getCP2Calculations,
    getCP3Calculations,
    fetchEquipmentsHandler,
    fetchEquipmentsChargePumpOne,
    fetchEquipmentsChargePumpTwo,
    fetchEquipmentsChargePumpThree,
    getgkxCapacityGraphData,
    getCP1CapacityGraphData,
    getCP2CapacityGraphData,
    getCP3CapacityGraphData
);
